import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Register German locale data BEFORE bootstrapping
registerLocaleData(localeDe, 'de-DE');

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
